// extracted by mini-css-extract-plugin
export default {"popoverPaper":"popoverPaper--J7CZ5","header":"header--dNSgL","backdrop":"backdrop--UX5XL"};